export default __webpack_public_path__ + "static/media/beach.d1908973.mp3";